import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconAddUser } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { ROOM_INVITE_TOGGLE_EVENT } from '../../../vrs-layout/groupInvite';
import { hasClientCallActions } from '../../clientCallActions.web';
/**
 * The toolbar's Invite for a signed-in client: it opens the room's invite
 * panel (InvitePanel.web.tsx: ring someone in by @handle, email or contact
 * with live status, or share an expiring guest link), in every room, platform
 * and interpreted alike. It replaced the Invite in the floating room pill;
 * Jitsi's own add-people dialog (dial-in numbers, meeting URL) was never the
 * right invite for these calls. Interpreters, guests and observers do not see
 * it.
 */
class VrsInviteButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.invite';
        this.icon = IconAddUser;
        this.label = 'toolbar.invite';
        this.tooltip = 'toolbar.invite';
    }
    /**
     * Opens (or closes) the room's invite panel.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        sendAnalytics(createToolbarEvent('invite'));
        window.dispatchEvent(new CustomEvent(ROOM_INVITE_TOGGLE_EVENT));
    }
}
/**
 * Maps state to props: only a signed-in client in a call sees Invite.
 *
 * @param {IReduxState} state - The redux state.
 * @param {AbstractButtonProps} ownProps - The component's own props.
 * @returns {Object}
 */
function _mapStateToProps(state, ownProps) {
    return {
        visible: ownProps.visible ?? hasClientCallActions(state)
    };
}
export default translate(connect(_mapStateToProps)(VrsInviteButton));
